import { useState } from 'react';

export function usePageInput(limit = 30, offset = 0) {
  const [pageInput, setPageInput] = useState({
    limit,
    offset,
    query: '',
  });

  function handlePagination({ limit, offset }) {
    setPageInput({
      ...pageInput,
      limit,
      offset,
    });
  }

  function handleQuery(e) {
    const query = e.target.value;
    setPageInput({
      ...pageInput,
      query,
      // reset offset
      offset: 0,
    });
  }

  function resetOffset() {
    setPageInput({
      ...pageInput,
      offset: 0,
    });
  }

  return { pageInput, handlePagination, handleQuery, resetOffset };
}
